import api from "@/lib/api";

export async function finalizarSolicitacao(id) {
  const { data } = await api.post("/secretaria-digital/solicitacao/finalizar", { id })
  return data
}